import { BaseModel } from "../base.model";

export class CategoryModel extends BaseModel {
    name?: string;
    imageUrl?: string;
}